import { useState } from "react";
import GlobIcon from "../../Icons/GlobIcon";
import { AnimatePresence, LayoutGroup, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import "../../i18n"; // Import the i18n initialization file

export default function LanguageSelector() {
  const [showPanel, setShowPanel] = useState(false);
  const { i18n } = useTranslation();

  const languages = [
    { label: "Bahasa", code: "id" }, // Indonesian
    { label: "DEUTSCH", code: "de" }, // German
    { label: "Eesti", code: "et" }, // Estonian
    { label: "ENG", code: "en" }, // English
    { label: "Español", code: "es" }, // Spanish
    { label: "Latviešu", code: "lv" }, // Latvian
    { label: "Lietuvių", code: "lt" }, // Lithuanian
    { label: "русский", code: "ru" }, // Russian
    { label: "عربي", code: "ar" }, // Arabic
    { label: "हिन्दी", code: "hi" }, // Hindi
    { label: "ไทย", code: "th" }, // Thai
  ];

  // Get the current language's display label
  const currentLang =
    languages.find((lang) => lang.code === i18n.language)?.label || "ENG";

  const onClickHandler = () => {
    setShowPanel((prev) => !prev);
  };

  const onSelectHandler = (lang) => {
    setShowPanel(false);
    i18n.changeLanguage(lang.code);
  };

  return (
    <>
      <motion.button
        layoutId="base-button"
        onClick={onClickHandler}
        className="absolute top-6 right-10 flex items-center justify-center uppercase border border-white rounded-[22px] text-white py-1 px-2 text-sm font-semibold tracking-tight"
      >
        {currentLang} <GlobIcon className="w-6 h-6 text-white ml-1" />
      </motion.button>

      <AnimatePresence>
        {showPanel && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="bg-black/90 size-full fixed z-40 inset-0"
            onClick={() => setShowPanel(false)}
          ></motion.div>
        )}
      </AnimatePresence>

      {showPanel && (
        <LayoutGroup>
          <motion.div
            initial={{ opacity: 0.5 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0.5 }}
            className="bg-primary-black h-full w-44 rounded-s-[30px] fixed z-50 top-0 right-0 flex flex-col justify-center items-center gap-5"
          >
            {languages.map((lang) => (
              <motion.button
                key={lang.code}
                layoutId={
                  currentLang === lang.label
                    ? "base-button"
                    : `${lang.label}-button`
                }
                onClick={() => onSelectHandler(lang)}
                className={`rounded-[22px] py-1.5 px-2 border border-white text-xs tracking-tight ${
                  currentLang === lang.label
                    ? "text-primary-black bg-white"
                    : "text-white bg-primary-black"
                }`}
              >
                {lang.label}
              </motion.button>
            ))}
          </motion.div>
        </LayoutGroup>
      )}
    </>
  );
}
